<template>
    <va-create-layout>
        <FbaInventory-form :title="title" :item="item"></FbaInventory-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
